import axios from 'axios'
import { BASE_URL } from './base-url'

var base = BASE_URL;

export default class ApiKeyService {

    getApiKeys(params, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/apikeys',
                method: 'get',
                params: params,
                headers: {
                    'Authorization': 'Basic ' + token
                },
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    postApiKey(apiKey, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/apikeys',
                method: 'post',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json',
                },
                data: apiKey
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }



    deleteApiKey(uuid, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/apikeys/' + uuid,
                method: 'delete',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json'
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }


}